// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"e8a41623","182":"f70acce1","223":"15b31948","413":"d4f3933b","461":"1820cfae","644":"b4522c95","851":"9e381f4e","897":"ceefa4a7","969":"f3102a33"}[chunkId] + ".chunk.js";
};